import { Z_INDEX_OVERLAY_SEARCH } from '../../../constants/z_index';
export const growthInAppSidepanelIframeStyle = {
  position: 'fixed',
  display: 'flex',
  flexDirection: 'column',
  top: 0,
  right: 0,
  zIndex: Z_INDEX_OVERLAY_SEARCH,
  width: 0,
  height: '100%'
};